import React from 'react';
import { Form, Button, Table, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { isBrowser } from 'react-device-detect';

import 'rc-tree/assets/index.css';
import Tree, { TreeNode } from 'rc-tree';

import SortTable from '../../components/SortTable';
import { I18n } from '../../utils/I18n';
import Settings from '../../Settings';


import UserProtocol from '../../net/UserProtocol';

/*eslint eqeqeq: "off"*/

const Columns = {
  UserID: 0,
  UserName: 1,
  Organize: 2,
  Part: 3,
  Permission: 4,
  EMail: 5,
  State: 6
};

let defaultChecked = "0"

const root = process.env.PUBLIC_URL + "/";



export default class UserListPage extends React.Component {
  constructor(props) {
    super(props);

    this.CompanyTreeComponent = (<div></div>);

    this.state = {
      CompanyNewTree: null,
      GroupCount: 0,
      BrandCount: 0,
      StoreCount: 0,
      ShowCompanyTree: true,
      RolePermission: true,
      value: "0",

      copyRoleNum:0,

      AdminCount: 0,
      EditorCount: 0,
      ViewerCount: 0,

      VisibleEnableAll: true,
      VisibleSelectAll: true,

      AllenableSet: new Set(),
      PermissionSList: [],

      SearchBarValue: "",
      NowSelect: 1,
      AuthoritieCheckBoxArray: [],

      showCreateRoleModal: false,
      showEditRoleNameModal: false,
      showDeleteModal:false,

      CheckEnableAll:true,
      CheckSelectAll:true,

      checkedKeys: [],
      checkedALLKeys: [],

      ClickAuthoritieKey: [],

      checked: [],
      expanded: [],

      EditInputName: "",

      DisplayRoleName:"",

    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleEditInputNameChange = this.handleEditInputNameChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.UserListTableRef = React.createRef();
    console.log('Permission setting page');
  }

  componentDidMount() {
    //TODO: group id
    fetch("/api/company/subsidiary", { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          console.log('現在開始拿樹狀資料:::');
          console.log(JSON.stringify(result.data));

          this.setState({ CompanyNewTree: [result.data] });

          this.initNewCompanyTree(this.state.CompanyNewTree);
        },
        (error) => {
          console.log("error in UserList:", error)
        }
      );

    fetch("/api/company/permission/role/list", { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          console.log('現在開始拿role list:::');
          this.setState({ AuthoritieCheckBoxArray: result.data });
          this.setState({ EditInputName:this.state.AuthoritieCheckBoxArray[0].name});
        },
        (error) => {
          console.log("role list錯誤:", error);
        }
      );

    fetch("/api/company/permission/authority/list", { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {


          let repeatSet = new Set();
          let PermissionList = [];

          result.data.forEach(element => {

            repeatSet.add(element.group);
            PermissionList.push(element);
          })

          this.setState({ AllenableSet: repeatSet });
          this.setState({ PermissionSList: PermissionList });

        },
        (error) => {
          console.log("勾選選項錯誤:", error)
        }
      );

    // componentDidMount結束
  }


  // 第三欄初始化
  setTotreeAllEnable = () => {
    let mySet = this.state.AllenableSet;

    let EmptyArr = [];

    mySet.forEach(item => {

      EmptyArr.push(item);
    }
    );
    return (EmptyArr.map(item =>
      <TreeNode title={item} key={item}
      >
      </TreeNode>
    ));
  };

  // 第四欄初始化
  setTotreeAllSeclect = () => {

    let nodes = [];
    this.state.PermissionSList.map(element => {
      if (this.state.checkedKeys.includes(element.group)) {
        nodes.push(
          <TreeNode title={element.name} key={element.id} >
          </TreeNode>
        )
      }
    })
    if (nodes.length > 0)
      return nodes;
    else
      return null;
  };

  handleInputChange=(event)=>{
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({[name]: value});
  }



  onDrop = (info) => {
    const dragKey = info.dragNode.props.eventKey; //移動者
    const dropKey = info.node.props.eventKey; //目標位置
    //const dropPos = info.node.props.pos.split('-');
    //const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]); //新位置在目標位置的上中下哪個位置

    const dragItemKeys = dragKey.split("_");
    const dropItemKeys = dropKey.split("_");
    const dragItemLevel = dragItemKeys.length;
    const dropItemLevel = dropItemKeys.length;

    if (dragItemLevel < 2) { //移動的是集團
      return;
    }
    if (dragItemLevel !== dropItemLevel &&
      dragItemLevel - 1 !== dropItemLevel) {  //目標位置層級必須與移動者相同或者是移動者的上一層
      return;
    }
    if (dragItemLevel === 2) { //移動的是品牌
      if (dragItemKeys[0] === dropItemKeys[0]) { //目的地集團跟原集團是同一個
        return;
      }
    }
    if (dragItemLevel === 3) {  //移動的是分店
      if (dragItemKeys[0] === dropItemKeys[0] &&
        dragItemKeys[1] === dropItemKeys[1]) { //目的地品牌跟原品牌是同一個
        return;
      }
    }

    const findGroup = (data, groupid, callback) => {
      data.forEach((item, index, arr) => {
        if (item.GroupId == groupid) {
          callback(item, index, arr);
          return;
        }
      });
    }
    const findBrand = (data, groupid, brandid, callback) => {
      let group = null;
      findGroup(data, groupid, (item, index, arr) => {
        group = item;
      });
      if (group !== null) {
        group.Brand.forEach((item, index, arr) => {
          if (item.BrandId == brandid) {
            callback(item, index, arr);
            return;
          }
        });
      }
    }
    const findStore = (data, groupid, brandid, storeid, callback) => {
      let brand = null;
      findBrand(data, groupid, brandid, (item, index, arr) => {
        brand = item;
      });
      if (brand !== null) {
        brand.Store.forEach((item, index, arr) => {
          if (item.StoreId == storeid) {
            callback(item, index, arr);
            return;
          }
        });
      }
    }

    let CompanyTree = this.state.CompanyNewTree;
    //開始移動位置
    if (dragItemLevel === 2) { //移動的是品牌
      let dragBrand;
      findBrand(CompanyTree, dragItemKeys[0], dragItemKeys[1], (item, index, arr) => {
        arr.splice(index, 1);
        dragBrand = item;
      });
      findGroup(CompanyTree, dropItemKeys[0], (item, index, arr) => {
        item.Brand.push(dragBrand);
      });
    } else {  //移動的是分店
      let dragStore;
      findStore(CompanyTree, dragItemKeys[0], dragItemKeys[1], dragItemKeys[2], (item, index, arr) => {
        arr.splice(index, 1);
        dragStore = item;
      });
      findBrand(CompanyTree, dropItemKeys[0], dropItemKeys[1], (item, index, arr) => {
        item.Store.push(dragStore);
      });
    }

    console.log("drag done.");
    this.initCompanyTree(CompanyTree);
  }


  // 最左邊樹狀結構的呈現
  initNewCompanyTree(CompanyTree) {
    let GroupCount = 0;
    let BrandCount = 0;
    let StoreCount = 0;

    this.CompanyNewTreeComponent = (
      <div style={{ height: "100%", overflowY: "auto" }}>
        <Tree defaultExpandAll={true} showIcon={false} showLine={true}
              onClick={(e, node) => {
              // alert(node.props.eventKey ) ;

              fetch("/api/company/"+node.props.eventKey+"/permission/role/list", { credentials: 'include' })
              .then(res => res.json())
              .then(
                (result) => {
                  console.log('公司選擇:::');
                  console.log(JSON.stringify(result.data));
                  this.setState({AuthoritieCheckBoxArray:result.data});
                  this.setState({checkedALLKeys: []});
                  if (result.data.length==0){
                    this.setState({NowSelect:0});
                  }

                },
                (error) => {
                  console.log("error in 公司選擇:", error)
                }
              );


              
            
            }}
        
        >
          {
            CompanyTree.map((group) => {
              GroupCount++;
              return <TreeNode key={group.id} title={group.name}>
                {
                  group.subsidiaries.map((brand) => {
                    BrandCount++;
                    return <TreeNode key={brand.id} title={brand.name}>
                      {
                        brand.subsidiaries.map((store) => {
                          StoreCount++;
                          return <TreeNode key={store.id} title={store.name} />
                        })
                      }
                    </TreeNode>
                  })
                }
              </TreeNode>
            })
          }
        </Tree>
      </div>
    );

    this.setState({
      CompanyTree,
      GroupCount,
      BrandCount,
      StoreCount
    });

  };



  handleChange(event) {
    this.setState({ value: event.target.value });
    alert(event.target.value);
    defaultChecked = event.target.value
  }

  handleSubmit(event) {
    alert('Your favorite flavor is: ' + defaultChecked);

  }


  handleSearchInputChange(e) {
    this.setState({ SearchBarValue: e.target.value });

  }

  // 左上角input 跟第二欄 角色權限選擇角色一致
  handleSelectSyn = () => {

    
    let node = [];
    this.state.AuthoritieCheckBoxArray.forEach(element =>
      node.push(<option value={element.id}>{element.name}</option>)
    )
    return (node)
  }

  // modal中把 value轉成title
  SelectValueToTitle = () => {

    for (let i = 0; i < this.state.AuthoritieCheckBoxArray.length; i++) {

      if (this.state.AuthoritieCheckBoxArray[i].id == this.state.NowSelect) {

        return (<span className="ml-3" style={{ width: "60%" }}>{this.state.NowSelect}</span>)
      }
    }
  }

  SelectValueToTitle2 = () => {
    for (let i = 0; i < this.state.AuthoritieCheckBoxArray.length; i++) {
      if (this.state.AuthoritieCheckBoxArray[i].id == this.state.NowSelect) {
        return (<span className="ml-3" style={{ width: "60%" }}>{this.state.AuthoritieCheckBoxArray[i].name}</span>)
      }
    }
  }

onChangeCAllEnable=(e)=>{
  let key = e.target.value;
  this.setState({CheckEnableAll : !this.state.CheckEnableAll});
  let EmptyArr = [];
  const TheSet= this.state.AllenableSet;
  TheSet.forEach(item => {
    EmptyArr.push(item);
  });
  if (this.state.CheckEnableAll== true){
    this.setState({ checkedKeys:EmptyArr})
  }
  else{
    this.setState({ checkedKeys:[]})
  }
}


onChangeCAllSelect=(e)=>{
  let key = e.target.value;
  this.setState({CheckSelectAll : !this.state.CheckSelectAll});

  console.log(this.state.PermissionSList);
  let EmptyArr = [];
  let OPLIST= this.state.PermissionSList;
  OPLIST.forEach(item => {
    EmptyArr.push(item.id.toString());
  });
  if (this.state.CheckSelectAll== true){
    this.setState({ checkedALLKeys:EmptyArr})
  }
  else{
    this.setState({ checkedALLKeys:[]})
  }
}




  // 修改名稱EditInputName setstate
  handleEditInputNameChange(event) {
    this.setState({ EditInputName: event.target.value });
  };

  CopyRoleAut=()=>{
    let node=[];

    this.state.AuthoritieCheckBoxArray.forEach(element => {
      node.push(<option value={element.id}>{element.name}</option>)
    })
    return node;

  }


  render() {
    return (
      <div className="d-flex align-items-end flex-column" style={{ height: "94vh", paddingTop: "20px", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "0px" }}>
        <div className="d-flex flex-row align-items-center w-100">
          <h4><b><u><FormattedMessage id="PermissionSetting.MainPage.Title" /></u></b></h4>

        </div>
        <div className="clearfix w-100" style={{ marginTop: "20px" }}>
          <div className="float-left d-flex flex-row" style={{ width: (isBrowser ? "70%" : "100%") }}>
            <Form.Group controlId="contrlSelect"   >
              <Form.Control size="sm" as="select" value={this.state.NowSelect}
                onChange={
                  (event) => {
                    this.setState({ NowSelect: event.target.value });
                    let whoreNewArray = [];
                    for (let i = 0; i < this.state.AuthoritieCheckBoxArray.length; i++) {
                      
                      if (event.target.value == this.state.AuthoritieCheckBoxArray[i].id) {
                        this.setState({ EditInputName: this.state.AuthoritieCheckBoxArray[i].name });

                        for (let j = 0; j < this.state.AuthoritieCheckBoxArray[i].authorities.length; j++) { whoreNewArray.push(this.state.AuthoritieCheckBoxArray[i].authorities[j].id.toString()); }
                        this.setState({ checkedALLKeys: whoreNewArray });
                      }
                    }
                  }
                }>

                {this.handleSelectSyn()}
              </Form.Control>

            </Form.Group>
            {/* 套用按鈕 */}
            <Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "5px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
            onClick={() => {
              let RoleName="";
              let NewAuthoritieRAY=[];
              let NumRay=[];
              let CheckALL=this.state.AuthoritieCheckBoxArray;;
              // alert(this.state.checkedALLKeys)
              // alert(JSON.stringify(this.state.PermissionSList))
              for (let ck = 0; ck < this.state.checkedALLKeys.length; ck++) {
                this.state.PermissionSList.forEach(element=>{
                  if (element.id == this.state.checkedALLKeys[ck]){
                    NewAuthoritieRAY.push(element);
                    NumRay.push(element.id);
                  }
                })
              };

              CheckALL.forEach(element=>{
                if (element.id == this.state.NowSelect){
                  element.authorities=NewAuthoritieRAY
                }
              });
              this.setState({AuthoritieCheckBoxArray:CheckALL});
              this.state.AuthoritieCheckBoxArray.forEach(element => {
                if (element.id == this.state.NowSelect){
                  RoleName=element.name
                }
              })

              fetch("/api/company/permission/role/"+this.state.NowSelect,
              {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                method: "PUT",
                body: JSON.stringify({
                  "name": RoleName ,
                  "authorities": NewAuthoritieRAY,
                })
              })
              .then(function (res) { console.log(res) })
              .catch(function (res) { console.log(res) });

            }}
            ><FormattedMessage id="global.use" /></Button>

            {/* 刪除 */}
            <Button variant="outline-dark" className="h-100" size="sm"
              onClick={
                () =>{
                  this.setState({showDeleteModal:true})
              }
            }
              style={{ marginLeft: "5px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)", color: "blue" }}
            ><FormattedMessage id="global.delete" /></Button>

            {/* 修改名稱 */}
            <Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "5px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
              onClick={() => {
                this.setState({ showEditRoleNameModal: true });

              }}
            ><FormattedMessage id="global.editName" /></Button>

            {/* Delete modal開始 */}

 <Modal aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showDeleteModal} onHide={() => { this.setState({ showDeleteModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="PermissionSetting.MainPage.DeleteRole" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="ml-3 mb-2 row" >
                  <text style={{ width: "30%" }}>{"角色名稱(ID): "}</text>
                  <span className="ml-3" style={{ width: "60%" }}>{this.state.NowSelect}</span>
                </div>
                <div className="ml-3 mb-2 row" >
                  <text style={{ width: "30%" }}>{"角色顯示名稱 : "}</text> 
                  {
                    this.SelectValueToTitle2()
                  }
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({ showDeleteModal: false }) }}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={() => {


 let NewAuthoritieCheckBoxArray = this.state.AuthoritieCheckBoxArray;

                NewAuthoritieCheckBoxArray.forEach((item, index, object) => {

                  // alert(role.id)
                  if (item.id== this.state.NowSelect){
                    object.splice(index, 1);
                  }
                })
                this.setState({AuthoritieCheckBoxArray:NewAuthoritieCheckBoxArray});

                
                  fetch("/api/company/permission/role/"+this.state.NowSelect,{credentials: 'include'
                  ,method: "DELETE"
                })
                  .then(res => res.json())
                  .then(
                    (result) => {
                console.log("Delete Role::::")      
                console.log(JSON.stringify(result))
                try{
                  if (result.resultCode== "SUCCESS"){
                    this.setState({NowSelect:this.state.AuthoritieCheckBoxArray[0].id});
                    this.setState({EditInputName:this.state.AuthoritieCheckBoxArray[0].name});
                  }
                }
                catch(err){console.log(err)};
                if (result.resultCode== "ROLE_NOT_EXIST"){this.setState({NowSelect:0}) ;}
                    },
                    (error) => {
                    console.log("error in delete role:",error)
                    }
                  )

                  

                  this.setState({ showDeleteModal: false })
                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>

            {/* 刪除MODAL結束 */}

            {/* 修改名稱modal開始 */}

            <Modal aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showEditRoleNameModal} onHide={() => { this.setState({ showEditRoleNameModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="PermissionSetting.MainPage.EditName" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="ml-3 mb-2 row" >
                  <text style={{ width: "30%" }}>{"角色名稱(ID): "}</text>
                  {
                    this.SelectValueToTitle()
                  }

                  {/* {this.defaultGetInputEditValue()} */}

                  {/* <span className="ml-3" style={{width:"60%"}}>{element.name}</span> */}
                </div>
                <div className="ml-3 mb-2 row" >
                  <text style={{ width: "30%" }}>{"修改角色顯示名稱 : "}</text> <input className="ml-3" type="text" style={{ width: "60%" }}
                    value={this.state.EditInputName} onChange={this.handleEditInputNameChange}
                  ></input>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({ showEditRoleNameModal: false }) }}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={() => {
                    this.setState({ showEditRoleNameModal: false });
                    let NewAuthoritieCheckBoxArray = this.state.AuthoritieCheckBoxArray;
                    let TemAuthority = [];
                    NewAuthoritieCheckBoxArray.forEach(role => {

                     
                      if (role.id== this.state.NowSelect){
                        role.name=this.state.EditInputName;
                        TemAuthority=role.authorities;
                      }
                    })
                    this.setState({AuthoritieCheckBoxArray:NewAuthoritieCheckBoxArray});


                    fetch("/api/company/permission/role/"+this.state.NowSelect,
                    {
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      method: "PUT",
                      body: JSON.stringify({

                        "name": this.state.EditInputName,
                        "authorities": TemAuthority,
                      })
                    })
                    .then(function (res) { console.log(res) })
                    .catch(function (res) { console.log(res) });





                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>

            {/* 修改名稱按鈕結束 */}



            {/* 創建角色 */}
            <Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "5px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
              onClick={() => { this.setState({ showCreateRoleModal: true }) }}
            >
              <FormattedMessage id="PermissionSetting.MainPage.CreateRole" /></Button>

            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showCreateRoleModal} onHide={() => { this.setState({ showCreateRoleModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="PermissionSetting.MainPage.CreateRole" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>

                <div className="ml-3 mb-2 row" >
                  <text><FormattedMessage id="PermissionSetting.MainPage.DisplayName" /></text> 
                  <input className="ml-3" type="text" style={{ width: "60%" }}
                    name="DisplayRoleName" value={this.state.DisplayRoleName} 
                    onChange={this.handleInputChange}></input>
                </div>

                <div className="ml-3 mb-2 row" >
                  <text><FormattedMessage id="PermissionSetting.MainPage.CopyRole" /></text> <select
                  value={this.state.copyRoleNum} 
                  onChange={
                    (event) => {
                      this.setState({copyRoleNum : event.target.value });


                    }}
                  style={{ width: "60%", marginLeft: "10%" }}>

                    <option value={0} >無</option>
                    {this.CopyRoleAut()}

                  </select>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({ showCreateRoleModal: false }) }}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={() => {
                    // 創建角色不能為空
                    this.setState({ showCreateRoleModal: false });
                    if (this.state.DisplayRoleName==""){
                      alert(I18n.t('PermissionSetting.MainPage.DisplayNameEmpty'))
                      return
                    };

                    // 尋找複製角色的權限
                    let Authoritieray = [];
                    let NewAuthoritieCheckBoxArray = this.state.AuthoritieCheckBoxArray;
                    NewAuthoritieCheckBoxArray.forEach(element => {
                      if (element.id == this.state.copyRoleNum){
                        Authoritieray=element.authorities;
                      }
                    })

                    let appendNewRole=(res)=>{

                      let {id, name, authorities}=res.data;
                      let NewAuthoritieCheckBoxArray = this.state.AuthoritieCheckBoxArray;
                      NewAuthoritieCheckBoxArray.push({"id":id,"name":name,"authorities": authorities})
                      this.setState({NowSelect:res.data.id, AuthoritieCheckBoxArray:NewAuthoritieCheckBoxArray});
                      
                      let UUPON =[];
                      authorities.forEach(element => UUPON.push(element.id));
                      this.setState({checkedALLKeys:UUPON});
                      this.setState({EditInputName:name});
                    }

                    fetch("/api/company/permission/role",
                      {
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({
                          "name": this.state.DisplayRoleName,
                          "authorities": Authoritieray,
                        })
                      })
                      .then(
                        function (res) { 
                        res.json().then(appendNewRole.bind(this)) ;
                      }
                       )
                      .catch(function (res) { console.log(res) });
                      // this.setState({NowSelect:createID})
                      console.log(this.state.NowSelect);
                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>

            {/* 創建角色結束 */}

          </div>

          {/* 顯示設置腳部 */}
        </div>
        <div className="mt-auto w-100" style={{ height: "75%" }}>
          {this.renderMainTable()}
        </div>
        <div className="mt-auto w-100 d-flex justify-content-end">
          {I18n.t('global.version', { version: Settings.sys.version })}
        </div>
        {this.renderFooter()}
      </div>
    );
  }

  renderMainTable() {
    return (
      <Table bordered size="sm" style={{ backgroundColor: "#fff", height: "100%" }}>
        <thead>
          <tr style={{ backgroundImage: "url('/images/bar_bg.png')", backgroundSize: "100% 100%" }}>

            {/* 第一欄樹狀資料頭部 */}
            {
              this.state.ShowCompanyTree ?
                <th style={{ width: "15%" }} className="text-primary">
                  <FormattedMessage id="userListPage.tree.group" values={{ count: this.state.GroupCount }} /><FormattedMessage id="userListPage.tree.split" />
                  <FormattedMessage id="userListPage.tree.brand" values={{ count: this.state.BrandCount }} /><FormattedMessage id="userListPage.tree.split" />
                  <FormattedMessage id="userListPage.tree.store" values={{ count: this.state.StoreCount }} />
                </th>
                : null
            }

            {/* 第二欄頭部 */}
            {
              this.state.RolePermission ?
                <th style={{ width: "10%" }} className="text-primary">

                  
                  <FormattedMessage id="PermissionSetting.MainPage.RolePermission" style={{ display: "inline-block" }} />

                </th>
                : null
            }

            {/* 第三欄頭部 */}

            {
              this.state.VisibleEnableAll ?
                <th style={{ width: "20%" }} className="text-primary">

                  <Form.Check type="checkbox" value={this.state.CheckEnableAll} onChange={this.onChangeCAllEnable} style={{ display: "inline-block" }} />
                  <FormattedMessage id="PermissionSetting.MainPage.Allenable" style={{ display: "inline-block" }} />

                </th>
                : null
            }
            {/* 第4欄頭部 */}
            {
              this.state.VisibleSelectAll ?
                <th style={{ width: "20%" }} className="text-primary">
                  <Form.Check type="checkbox"
                  value={this.state.CheckSelectAll} 
                  onChange={this.onChangeCAllSelect}
                  style={{ display: "inline-block" }} />
                  <FormattedMessage id="PermissionSetting.MainPage.Allclick" />
                </th>
                : null
            }

          </tr>
        </thead>
        <tbody>
          <tr>
            {/* 第一欄 tree*/}

            {
              this.state.ShowCompanyTree ?
                <td style={{ padding: "0px" }}>
                  {this.CompanyNewTreeComponent}
                </td>
                : null
            }

            {/* 第二欄  角色權限*/}
            {this.state.RolePermission ?
              <td style={{ padding: "0px" }}>
                <div style={{ height: "100%", overflowY: "auto" }}>
                  <Tree defaultExpandAll={true} showIcon={false} showLine={true}

                    onClick={(e, node) => {
                      this.setState({ NowSelect: node.props.eventKey });
                      // 先找出對應的Authority
                      let DisplaySet = new Set();
                      let AuthoritieArray = [];

                      this.state.AuthoritieCheckBoxArray.forEach(element => {
                        if (element.id == node.props.eventKey) {
                          
                          this.setState({ EditInputName: element.name });

                          element.authorities.forEach(authority => {
                            AuthoritieArray.push(authority.id.toString())
                            DisplaySet.add(authority.group)
                          });
                          this.setState({ checkedALLKeys: AuthoritieArray });

                        };
                      })


                    }}>
                    {this.renderPermissionRole()}
                  </Tree>

                </div>
              </td>
              : null
            }

            {/* 第三欄 全部啟用*/}

            {
              this.state.VisibleEnableAll ?
                <td style={{ padding: "0px" }}>
                  {this.renderEnableAll()}
                </td>
                : null
            }


            {/* 第四欄 全部選取*/}
            {
              this.state.VisibleSelectAll ?
                <td style={{ padding: "0px" }}>
                  {this.renderAllSelect()}
                </td>
                : null
            }

          </tr>
        </tbody>
      </Table>
    );
  }
  // 全部選取選了checkbox
  onAllSelectCheck = (checkedALLKeys) => {
    console.log(checkedALLKeys);
    this.setState({
      checkedALLKeys,
    });
  };

  // 全部啟用選了checkbox
  onEnableCheck = (checkedKeys) => {
    this.setState({
      checkedKeys,
    });
    
  };

  // 全部啟用checkbox 區域
  renderEnableAll() {
    return (
      <div style={{ height: "100%", overflowY: "auto" }}>
        <Tree defaultExpandAll={true} showIcon={false} showLine={true}
          checkable={true}
          onCheck={this.onEnableCheck}
          checkedKeys={this.state.checkedKeys}
        >
          {this.setTotreeAllEnable()}
        </Tree>
      </div>
    );
  }

  // 第二欄角色權限 tree 區域
  renderPermissionRole() {
    let nodes = [];

    this.state.AuthoritieCheckBoxArray.map(element => {
      nodes.push(
        <TreeNode title={element.name} key={element.id}>
        </TreeNode>
      )
    })
    if (nodes.length > 0)
      return nodes;
    else
      return null;

  }

  // 第4欄全部選取 tree區
  renderAllSelect() {
    return (

      <div style={{ height: "100%", overflowY: "auto" }}>
        <Tree defaultExpandAll={true} showIcon={false} showLine={false}
          checkable={true}
          onCheck={this.onAllSelectCheck}
          checkedKeys={this.state.checkedALLKeys}
        >
          {this.setTotreeAllSeclect()}
        </Tree>
      </div>
    )

  }



  renderFooter() {
    return (
      <footer className="mt-auto w-100" style={{ borderLeft: "1px solid #ccc" }}>
        <div className="d-flex flex-row h-25" >
          <div style={{ backgroundColor: "#fff", borderTop: "1px solid #ccc", borderRight: "1px solid #ccc", paddingLeft: '10px', paddingRight: '10px' }}>
            <FormattedMessage id="userListPage.displayset" />
          </div>
          <div className="flex-fill" style={{ borderBottom: "1px solid #ccc" }} ></div>
        </div>
        <div className="h-75 p-2" style={{ backgroundColor: "#fff", borderRight: "1px solid #ccc" }}>
          <span style={{ marginLeft: "20px" }}><FormattedMessage id="userListPage.dpset.column" /></span>
          <div className="d-flex flex-wrap">
            <Form.Check type="checkbox" id="dpset.orgtree" label={I18n.t("userListPage.dpset.orgtree")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setState((prev) => ({ ShowCompanyTree: !prev.ShowCompanyTree }))} checked={this.state.ShowCompanyTree} />


            <Form.Check type="checkbox" id="dpset.permissionrole" label={I18n.t("userListPage.table.permit")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setState((prev) => ({ RolePermission: !prev.RolePermission }))} checked={this.state.RolePermission} />

            <Form.Check type="checkbox" id="dpset.userid" label={I18n.t("PermissionSetting.MainPage.Allenable")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setState((prev) => ({ VisibleEnableAll: !prev.VisibleEnableAll }))} checked={this.state.VisibleEnableAll} />
            <Form.Check type="checkbox" id="dpset.username" label={I18n.t("PermissionSetting.MainPage.Allclick")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setState((prev) => ({ VisibleSelectAll: !prev.VisibleSelectAll }))} checked={this.state.VisibleSelectAll} />

          </div>
        </div>
      </footer>
    );
  }













}